import { getErrorPayload } from "@application/helpers/api-helper";
import InvitationApi from "@infrastructure/invitation-api";
import { createAsyncThunk } from "@reduxjs/toolkit";
export const getAllInvitationCountAsync = createAsyncThunk("invitation/getAllInvitationCount", async (_, { rejectWithValue }) => {
    try {
        const response = await InvitationApi.getAllInvitationCount();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getPaginatedInvitationsByEventIdAsync = createAsyncThunk("invitation/getPaginatedByEventId", async (query, { rejectWithValue }) => {
    try {
        const response = await InvitationApi.getPaginatedInvitationsByEventId(query);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const ExportToExcelAsync = createAsyncThunk("invitation/exportToExcel", async (query, { rejectWithValue }) => {
    try {
        const response = await InvitationApi.ExportToExcel(query);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteInvitationAsync = createAsyncThunk("invitation/deleteInvitation", async (query, { rejectWithValue }) => {
    try {
        const response = await InvitationApi.deleteInvitation(query);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const archivingTogglingInvitationAsync = createAsyncThunk("invitation/archivingToggelingInvitation", async (command, { rejectWithValue }) => {
    try {
        const response = await InvitationApi.ArchivingToggelingInvitation(command);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getInvitationStatsAsync = createAsyncThunk("invitation/getInvitationStats", async (eventId, { rejectWithValue }) => {
    try {
        const response = await InvitationApi.getInvitationStats(eventId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getInvitationDatesByInvitationIdAsync = createAsyncThunk("invitation/getInvitationDates", async (id, { rejectWithValue }) => {
    try {
        const response = await InvitationApi.getInvitationDatesByInvitationId(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getInvitationDatesForByInvitationIdWithPreAccDateAsync = createAsyncThunk("invitation/getInvitationDatesForAccommodation", async (id, { rejectWithValue }) => {
    try {
        const response = await InvitationApi.getInvitationDatesForByInvitationIdWithPreAccDate(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getInvitationDatesByUserIdAsync = createAsyncThunk("invitation/getDatesByUserId", async (userId, { rejectWithValue }) => {
    try {
        const response = await InvitationApi.getInvitationDatesByUserId(userId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
